import { http } from 'lib/client/http';
import { sha256 } from 'js-sha256';
import { ISignInRequestData } from '../model/SignIn.model';

export function signIn(data: ISignInRequestData) {
    const params = {
        username: data.email,
        password: sha256(data.password),
        grant_type: 'password',
        scope: 'profile',
        client_id: process.env.REACT_APP_CLIENT_ID,
        redirect_uri: process.env.REACT_APP_REDIRECT_URI,
    };

    return http.post('/signin', params, {});
}
